<template>
  <Standard
    v-if="visible"
    modal_id="cam-production-photo-preview"
    size="xl"
    :title="$t('Photo preview')"
    :subtitle="label"
    :decline_label="null"
    :light-layout="true"
    @hidden="$emit('close')"
  >
    <div class="p-4 bg-white">
      <img
        v-if="url"
        :src="url"
        :alt="$t('CAM photo preview')"
        class="img-fluid rounded-4 border preview-image"
      />

      <div class="d-flex justify-content-end mt-3">
        <button class="btn btn-violet rounded-pill" @click="$emit('download')">
          {{ $t("Download photo") }}
        </button>
      </div>
    </div>
  </Standard>
</template>

<script>
import Standard from "@/components/Modal/Standard.vue";

export default {
  name: "CamProductionIndexPhotoPreviewModal",
  components: {
    Standard,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  emits: ["close", "download"],
};
</script>

<style scoped>
.preview-image {
  max-height: 70vh;
  width: 100%;
  object-fit: contain;
}
</style>
